import $ from "jquery";

import BasePage from "@Scripts/Pages/BasePage";

export default class HomePage extends BasePage {
    public static async init() {
        await super.init();

        this.setVisuals();
    }

    private static setVisuals() {
        $(".app-visual .slider-visuals").slick({
            autoplay: true,
            arrows: false,
            fade: true,
            asNavFor: '.app-visual .slider-nav'
        });

        $('.app-visual .slider-nav').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.app-visual .slider-visuals',
            dots: false,
            centerMode: true,
            focusOnSelect: true
        });
    }
}